var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',[_c('breadcrumb-nav',{attrs:{"isLibrary":true}}),_c('articles-feed',{staticClass:"pt-120",attrs:{"title":_vm.category && _vm.category.name,"articles":_vm.articles}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }